export const formatFileNameWithVersion = (fileName: string, version?: string): string =>
  version
    ? `${fileName} | ${window.I18n.designSystem.fileItem.version.replace("%{version}", () => version)}`
    : fileName;
